import * as rolesApi from '@/api/roleApi.js'
import { useUserStore } from '@/stores/userStore'

export default {
    namespaced: true,
    state() {
        return {
            companyListRoles: []
        }
    },
    getters: {
        getListRoles(state) {
            return state.companyListRoles
        },
    },
    mutations: {
        setListRoles(state, listData) {
            state.companyListRoles = JSON.parse(listData)
        },
    },
    actions: {
        async listRoles({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await rolesApi.listRoles(token, id)

            if (dataResp) {
                commit('setListRoles', JSON.stringify(dataResp))
            }
        },
        async updateRole({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await rolesApi.update(token, data)
        },
        async createRole({ commit }, data) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await rolesApi.create(token, data)
        },
        async delRole({ commit }, id) {
            const token = useUserStore().token || JSON.parse(localStorage.getItem('user'))?.token
            if (!token) return

            const dataResp = await rolesApi.gelCompany(token, id)
        },
    }
}